import { createIamRole, updateIamRole, getPermissionsList, getSingleIamRole } from '@/libs/api/api';
import { message, loader } from '../../../../../libs/helper';
import constants from '@/libs/constant/constants';
import pageRoutes from '@/libs/constant/pageRoutes'
export default {
    data() {
        return {
            role_name: '',
            searchValue: '',
            columns: ['permissions_checkbox_all', 'permission', 'type', 'settings'],
            permissionsList: [],
            permissionsTableSettings: {
                headings: {
                    permissions_checkbox_all: 'permissions_checkbox_all',
                    permission: 'Permission name',
                    type: 'Type',
                    settings: 'settings'
                },
                pagination: { show: true},
                perPage: '25',
                filterable: [],
                filterByColumn: true,
                sortable: ['yes'],
                perPageValues:[]
            },
            selectedEntries: [],
            selectedTableFilters: {},
            category: '',
            tableFilters: {},
            sort: 'role',
            order: 'asc',
            limit: 25,
            currentPage: 1,
            skip: 0,
            previousPage : 1,
            rolesCount: {},
            pageSize: '10',
            tableDataCount: null,
            isAllPerissionsMarked: false,
            mode: 'create',
            btnLoading: false,
            createBtnDisabled: true,
            selectedRole: []
        }
    },
    computed: {
        perPageSelect: {
            get(){
                return this.pageSize
            },
            set(val){
                this.pageSize = val
                this.skip=0
                this.currentPage = 1
                this.fetchAllPermissions()
            }
        },
        params() {
            return `?skip=${this.skip}&limit=${this.pageSize}&sort=${this.sort}&order=${this.order}`
        },
        orgID() {
            return this.$attrs.currentOrganisation._id
        }
    },
    watch: {
        role_name(value) {
            if (value == '' || value == undefined)
                this.createBtnDisabled = true
            else
                this.createBtnDisabled = false
        }
    },
    mounted() {
        this.mode = this.$route.params.mode
        if ( this.mode === 'view') {
            this.$refs.tableHeaderCheckbox.$el.style.display = 'none'
            this.fetchSingleIamRole(true)
            // console.log(this.$refs.tableHeaderCheckbox.$el.style.display = 'none')
        } else if (this.mode === 'edit') {
            this.fetchSingleIamRole()
            this.fetchAllPermissions()
        } else {
            this.fetchAllPermissions()
        }
    },
    methods: {
        async fetchSingleIamRole(onlyView = false) {
            loader(this, true)
            await getSingleIamRole(this.$route.params.id).then((response) => {
                this.role_name = response.name
                this.selectedEntries = response.permissions.map((permissions) => {
                    return permissions._id
                })
                if (onlyView) {
                    this.tableDataCount = response.permissions.length
                    this.permissionsList = response.permissions.map((permission) => {
                        return {
                            _id: permission._id,
                            permission: permission.permission_name,
                            type: permission.permission_type,
                            isdefault: permission.isdefault === true ? true : false,
                        }
                    })
                }
                loader(this, false)
            }).catch((err) => {
                loader(this, false)
                message(this, constants.messageType.ERROR, (err))
            })
        },
        async fetchAllPermissions(){
            loader(this, true)
            let params = this.params
            let searchValue = this.searchValue
            let body = {searchText: searchValue}
            await getPermissionsList(params, body).then((res) => {
                this.tableDataCount = res.result.total_count
                this.permissionsList = res.result.items.map((permission) => {
                    return {
                        _id: permission._id,
                        permission: permission.permission_name,
                        type: permission.permission_type,
                        isdefault: permission.isdefault === true ? true : false,
                    }
                })
                loader(this, false)
            })
            .catch((err) => {
                loader(this, false)
                message(this, constants.messageType.ERROR, (err))
            })
        },
        async querySearch (query, cb) {
            if(query === undefined || query === '' || query.length < 2){
                return
            }
            let searchResult = []
            let params = ''
            let body = {searchText: query}
            await getPermissionsList(params, body).then((res) => {
                searchResult = res.result.items
            })
            // call callback function to return suggestion objects
            cb(searchResult);
        },
        handleSelectValue(val) {
            this.searchValue = val.permission_name || val.value
            this.fetchAllPermissions()
        },
        async clearSearchInput() {
            this.searchValue = ''
            this.skip = 0
            this.currentPage = 1
            await this.fetchAllPermissions()
        },
        toggleAllForPermissions(event) {
            this.isAllPerissionsMarked = event
            if (this.isAllPerissionsMarked) {
                this.$refs.setsTable.data.map((row) => {
                    const index = this.selectedEntries.indexOf(row._id)
                    if (!row.isdefault && this.searchValue !== row._id && index === -1) {
                        this.selectedEntries.push(row._id)
                    }
                })
            } else {
                this.$refs.setsTable.data.map((row) => {
                    const index = this.selectedEntries.indexOf(row._id)
                    if (index > -1 && !row.isdefault) {
                        this.selectedEntries.splice(index, 1);
                    }
                })
            }
        },
        handleCheckBoxSelectPermission(row) {
            let id = row
            if (!this.selectedEntries.includes(id)) {
                this.selectedEntries.push(id)
            } else {
                const index = this.selectedEntries.indexOf(id)
                if (index > -1) {
                    this.selectedEntries.splice(index, 1);
                }
            }
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            // this.skip = (currentPage - 1) * this.selectedValue
            this.skip = (currentPage - 1) * this.pageSize
            this.isAllPerissionsMarked = false
            // call api and and set updated data
            this.fetchAllPermissions()
        },
        goToRolesPage() {
            this.role_name = ''
            this.$router.push({ name: pageRoutes.iamRoles })
        },
        handleSubmitGroup() {
            this.btnLoading = true
            let name = this.role_name
            loader(this, true)
            if (name == '' && name == undefined) {
                message(this, constants.messageType.ERROR, ('Role name not entered'))
                this.btnLoading = false
                loader(this, false)
            }
            else {
                // make payload and params data
                let payload = {
                    name: name,
                    permission_id: this.selectedEntries,
                    organisation_id: this.orgID
                }
                if (this.mode === 'edit') {
                    payload.role_id = this.$router.currentRoute.params.id
                    this.editRole(payload)
                }
                else this.createRole(payload);
            }
        },
        async createRole(payload) {
            await createIamRole(payload).then((res) => {
                this.btnLoading = false
                loader(this, false)
                message(this, constants.messageType.SUCCESS, (res.message))
                this.goToRolesPage()
            }).catch((error) => {
                this.btnLoading = false
                loader(this, false)
                message(this, constants.messageType.ERROR, (error))
            })
        },
        async editRole(payload) {
            await updateIamRole(payload).then((res) => {
                this.btnLoading = false
                loader(this, false)
                message(this, constants.messageType.SUCCESS, (res.message))
                this.goToRolesPage()
            }).catch((error) => {
                this.btnLoading = false
                loader(this, false)
                message(this, constants.messageType.ERROR, (error.message))
            })
        },
    }
}